<template>
    <div v-if="loaded">
        <rkm-form
            ref="Form"
            class="mb-2"
        >
            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-date-picker
                        :end-validations="validations.periodo"
                        :max-date="additionals.dataAtual"
                        :range-inline="false"
                        :start-validations="validations.periodo"
                        end-label="Até"
                        range
                        start-label="Período de"
                        v-model="model.periodo"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-date-picker
                        :max-date="additionals.dataAtual"
                        :range-inline="false"
                        end-label="Até"
                        range
                        start-label="Período movimentação de"
                        v-model="model.periodoMovimentacao"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input-autocomplete
                        :repository="repositories.fila.paciente"
                        :request-query-string-params="filters"
                        :search-fields="pacienteSearchFields"
                        :text-field="p => `${p.nome}${p.nomeSocial ? ` (${p.nomeSocial})` : ''}${p.cns ? ` - ${p.cns}` : ''}`"
                        label="Paciente"
                        placeholder="Nome, Nome social, CNS, CPF, Data de nascimento ou Prontuário"
                        v-model="model.paciente"
                        @select="loadFrom('paciente')"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        :color="exibirTodosFiltros ? 'primary' : 'secondary'"
                        :title="exibirTodosFiltros ? 'Exibir menos filtros' : 'Exibir todos os filtros'"
                        @click.stop="exibirTodosFiltros = !exibirTodosFiltros"
                    >
                        <rkm-icon icon="filter" />
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col cols="1">
                    <rkm-form-input
                        :validations="validations.idadeDe"
                        label="Idade de"
                        number
                        v-model="model.idadeDe"
                    />
                </rkm-col>

                <rkm-col cols="1">
                    <rkm-form-input
                        :validations="validations.idadeAte"
                        label="Até"
                        number
                        v-model="model.idadeAte"
                    />
                </rkm-col>


                <rkm-col>
                    <rkm-form-select
                        :default-option-text="isReguladorRequired ? 'Selecione': 'Todas'"
                        :options="form.unidadesReguladoras"
                        :validations="validations.unidadeReguladora"
                        @change="loadFrom('unidade_reguladora')"
                        label="Unidade reguladora"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeReguladoraId"
                        value-field='id'
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :default-option-text="isReguladorRequired ? 'Selecione': 'Todos'"
                        :disabled="!model.unidadeReguladoraId"
                        :options="form.reguladores"
                        :validations="validations.regulador"
                        @change="loadFrom('regulador')"
                        label="Local de atendimento regulador"
                        show-default-option
                        text-field="nome"
                        v-model="model.reguladorId"
                        value-field='id'
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="form.unidadesSolicitantes"
                        @change="loadFrom('unidade_solicitante')"
                        default-option-text="Todas"
                        label="Unidade solicitante"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeSolicitanteId"
                        value-field='id'
                    />
                </rkm-col>

                <rkm-col v-if="!exibirTodosFiltros">
                    <rkm-form-select
                        :disabled="!model.unidadeSolicitanteId"
                        :options="form.infraestruturasSolicitantes"
                        @change="loadFrom('infraestrutura_solicitante')"
                        default-option-text="Todos"
                        label="Local de atendimento solicitante"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaSolicitanteId"
                        value-field='id'
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row v-if="!exibirTodosFiltros">
                <rkm-col

                    cols="auto"
                >
                    <rkm-button
                        @click="$refs.Form.validate($refs.DataTable.search)"
                        color="primary"
                    >
                        Buscar
                    </rkm-button>

                    <rkm-button
                        @click="resetFilters"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>

            <div v-show="exibirTodosFiltros">
                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :disabled="!model.unidadeSolicitanteId"
                            :options="form.infraestruturasSolicitantes"
                            @change="loadFrom('infraestrutura_solicitante')"
                            default-option-text="Todos"
                            label="Local de atendimento solicitante"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaSolicitanteId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.unidadesReferencia"
                            @change="loadFrom('unidade_referencia')"
                            default-option-text="Todas"
                            label="Unidade referência"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeReferenciaId"
                            value-field='id'
                        />
                    </rkm-col>


                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.usuariosSolicitantes"
                            @change="loadFrom('usuario_solicitante')"
                            default-option-text="Todos"
                            label="Profissional solicitante"
                            show-default-option
                            text-field="nome"
                            v-model="model.usuarioSolicitanteId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="form.prestadores"
                            @change="loadFrom('prestador')"
                            default-option-text="Todos"
                            label="Prestadores"
                            show-default-option
                            text-field="nome"
                            v-model="model.prestador"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-multiselect
                            :options="form.status"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('status')"
                            label="Status"
                            option-name-key="nome"
                            option-text-selecteds="status selecionado"
                            v-model="model.status"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.opcoesRetiradaProtocoloAgendamento"
                            @change="loadFrom('opcao_retirada_protocolo_agendamento')"
                            default-option-text="Todos"
                            label="Retirada de protocolo"
                            show-default-option
                            text-field="nome"
                            v-model="model.opcaoRetiradaProtocoloAgendamentoId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :load-all-automatically="false"
                            :options="form.grupos"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('grupo')"
                            label="Grupo"
                            option-name-key="nome"
                            option-text-selecteds="grupo"
                            v-model="model.grupos"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :load-all-automatically="false"
                            :options="form.exames"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('exame')"
                            label="Exame"
                            option-name-key="descricao"
                            option-text-selecteds="exame"
                            v-model="model.exames"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :load-all-automatically="false"
                            :options="form.procedimentosCirurgicos"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('procedimento_cirurgico')"
                            label="Procedimento cirúrgico"
                            option-name-key="descricao"
                            option-text-selecteds="procedimento cirúrgico"
                            v-model="model.procedimentosCirurgicos"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :load-all-automatically="false"
                            :options="form.especialidades"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('especialidade')"
                            label="Especialidade"
                            option-name-key="descricao"
                            option-text-selecteds="especialidade"
                            v-model="model.especialidades"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <rkm-form-multiselect
                            :options="form.prioridades"
                            :select-limit="null"
                            @update:dropdownClosed="loadFrom('prioridade')"
                            label="Prioridade"
                            option-name-key="nome"
                            option-text-selecteds="prioridade"
                            v-model="model.prioridades"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :repository="repositories.fila.cid"
                            :request-query-string-params="filters"
                            :search-fields="cidSearchFields"
                            :text-field="c => `${c.codigo} - ${c.nome}`"
                            label="CID"
                            v-model="model.cid"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-input-autocomplete
                            :repository="repositories.fila.ciap"
                            :request-query-string-params="filters"
                            :search-fields="ciapSearchFields"
                            :text-field="c => `${c.codigo} - ${c.descricao}`"
                            label="CIAP"
                            v-model="model.ciap"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <rkm-form-select
                            :options="form.sexos"
                            default-option-text="Todos"
                            label="Sexo"
                            show-default-option
                            text-field="descricao"
                            v-model="model.sexoId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate($refs.DataTable.search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetFilters"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </div>
        </rkm-form>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="selectAll"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedCols"
                        value-field="key"
                    />
                </rkm-dropdown>
            </template>

            <rkm-data-table
                :repository="repositories.fila"
                :request-params="camelObjectKeysToSnakeRecursive(filters)"
                :fields="fields"
                :tbody-tr-class="rowClass"
                class="fila"
                ref="DataTable"
                sort-by="posicao"
                hide-filters
            >
                <template v-slot:cell(itens)="{ value }">
                    <div
                        v-for="item in value"
                        :key="item"
                    >
                        {{ item }}
                    </div>
                </template>

                <template v-slot:cell(paciente)="{ item }">
                    <rkm-button
                        v-if="item"
                        :id="uniqueId(`paciente-icon-${item.id}`)"
                        small
                    >
                        <rkm-icon icon="user"/>
                    </rkm-button>

                    <rkm-popover
                        v-if="item"
                        :target="uniqueId(`paciente-icon-${item.id}`)"
                        triggers="hover"
                        placement="top"
                        title="Dados cadastrais"
                    >
                        <div>
                            <span>
                                <strong>Idade:</strong> {{ item.idade }}
                            </span>
                        </div>

                        <div>
                            <span>
                                <strong>Prontuário:</strong> {{ item.prontuario }}
                            </span>
                        </div>
                    </rkm-popover>

                    {{ item.pacienteNome }}
                </template>

                <template v-slot:cell(actions)="{ item }">
                    <rkm-dropdown
                        color="primary"
                        position="left"
                        no-caret
                        title="Ações"
                        small
                    >
                        <template #button-content>
                            <rkm-icon icon="bars" />
                        </template>

                        <rkm-dropdown-item @click="$refs.ModalDetalhe.open(item)">Exibir detalhes</rkm-dropdown-item>
                        <rkm-dropdown-item @click="handleImpressao(item)">Impressões</rkm-dropdown-item>
                        <rkm-dropdown-item @click="$refs.ModalTentativaContato.open(item)">Tentativas de contato</rkm-dropdown-item>

                        <rkm-dropdown-item
                            v-if="item.allowUpdateProtocoloAgendamento"
                            @click="$refs.ModalProtocoloAgendamento.open(item)"
                        >
                            Controle de protocolo agendamento
                        </rkm-dropdown-item>

                        <rkm-dropdown-item @click="$refs.ModalSolicitacao.open(item, !!model.reguladorId)">
                            {{ item.allowUpdate ? 'Atualizar' : 'Visualizar' }}
                        </rkm-dropdown-item>
                    </rkm-dropdown>
                </template>

                <template #afterTable>
                    <div class="my-2">
                        <p>A linha em <strong class="purple">roxo</strong> representa que o paciente está em óbito.</p>
                    </div>
                </template>
            </rkm-data-table>
        </rkm-area>

        <ModalDetalhe ref="ModalDetalhe" />
        <ModalImpressao ref="ModalImpressao" :origem="'fila'"/>
        <ModalTentativaContato ref="ModalTentativaContato" />
        <ModalProtocoloAgendamento ref="ModalProtocoloAgendamento" />

        <ModalSolicitacao
            @prioridade-change="$refs.DataTable.search()"
            @save="loadFromUnidadeReferencia"
            ref="ModalSolicitacao"
        />
    </div>
</template>

<script>
// Components.
import ModalDetalhe from './components/detalhe/Modal'
import ModalImpressao from './components/impressao/Modal'
import ModalTentativaContato from './components/tentativa-contato/Modal'
import ModalProtocoloAgendamento from './components/protocolo-agendamento/Modal'
import ModalSolicitacao from './components/solicitacao/Modal'

// Mixins.
import { repository, error, stringCase, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

// Enums.
import statusTipo from '@/enums/regulacao/statusTipo'

// Moment.
import moment from 'moment'

export default {
    components: {
        ModalDetalhe,
        ModalImpressao,
        ModalTentativaContato,
        ModalProtocoloAgendamento,
        ModalSolicitacao,
    },
    computed: {
        validations() {

            let isPeriodoPreenchido = this.model.periodo?.start || this.model.periodo?.end;

            let isPeriodoRequired = isPeriodoPreenchido || !(!!this.model.paciente
                || (this.model.status.length > 0 && this.model.grupos.length > 0)
                || (this.model.status.length > 0 && (this.model.exames.length > 0
                    || this.model.procedimentosCirurgicos.length > 0
                    || this.model.especialidades.length > 0)))

            return {
                periodo: { required: isPeriodoRequired },
                unidadeReguladora: { required: this.isReguladorRequired },
                regulador: { required: this.isReguladorRequired },
                idadeDe: { max: 3, min_value: 0, max_value: this.model.idadeAte ? this.model.idadeDe : 999 },
                idadeAte: { max: 3, min_value: this.model.idadeDe ? this.model.idadeDe : 0, max_value: 999 },
            }
        },
        isReguladorRequired() {

            return !this.model.unidadeSolicitanteId && !this.model.unidadeReferenciaId && !this.model.paciente
        },
        filters() {

            return this.camelObjectKeysToSnakeRecursive({
                periodo: {
                    start: this.model.periodo.start ? moment(this.model.periodo.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodo.end ? moment(this.model.periodo.end).format('DD/MM/YYYY') : null,
                },
                periodoMovimentacao: {
                    start: this.model.periodoMovimentacao.start ? moment(this.model.periodoMovimentacao.start).format('DD/MM/YYYY') : null,
                    end: this.model.periodoMovimentacao.end ? moment(this.model.periodoMovimentacao.end).format('DD/MM/YYYY') : null,
                },
                pacienteId: this.model.paciente?.id ?? null,
                idadeDe: this.model.idadeDe ?? null,
                idadeAte: this.model.idadeAte ?? null,
                unidadeReguladoraId: this.model.unidadeReguladoraId,
                reguladorId: this.model.reguladorId,
                unidadeSolicitanteId: this.model.unidadeSolicitanteId,
                infraestruturaSolicitanteId: this.model.infraestruturaSolicitanteId,
                unidadeReferenciaId: this.model.unidadeReferenciaId,
                usuarioSolicitanteId: this.model.usuarioSolicitanteId,
                prestador: this.model.prestador,
                status: this.model.status,
                opcaoRetiradaProtocoloAgendamentoId: this.model.opcaoRetiradaProtocoloAgendamentoId,
                grupos: this.model.grupos,
                exames: this.model.exames,
                procedimentosCirurgicos: this.model.procedimentosCirurgicos,
                especialidades: this.model.especialidades,
                prioridades: this.model.prioridades,
                cidId: this.model.cid?.id ?? null,
                ciapId: this.model.ciap?.id ?? null,
                sexoId: this.model.sexoId,
            })
        },
        optionalColumns() {

            return this.columns.filter(c => !(c.fixed || false))
        },
        fields() {

            return this.columns.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        columns() {

            return [
                { key: 'data', name: 'solicitacao.data', label: 'Data da solicitação', sortable: true },
                { key: 'posicao', name: 'posicao', label: 'Posição', sortable: true, fixed: true },
                { key: 'prioridadeNome', name: 'prioridade.nome', label: 'Prioridade', sortable: true },
                { key: 'itens', label: 'Procedimento(s) / Especialidade', fixed: true },
                { key: 'paciente', name: 'pacienteNome', label: 'Paciente', sortable: true },
                { key: 'pacienteIdade', label: 'Idade', class: 'text-center', sortable: true },
                { key: 'sexoDescricao', name: 'pacienteSexo.descricao', label: 'Sexo', sortable: true },
                { key: 'dataDesejada', name: 'solicitacao.dataDesejada', label: 'Data desejada', sortable: true },
                { key: 'dataMovimentacao', name: 'dataMovimentacao', label: 'Data da movimentação', sortable: true },
                { key: 'cidDescricao', name: 'cidDescricao', label: 'CID', sortable: true },
                { key: 'ciapDescricao', name: 'ciapDescricao', label: 'CIAP', sortable: true },
                { key: 'statusNome', name: 'status.nome', label: 'Status', sortable: true },
                { key: 'tempoEspera', name: 'tempoEspera', label: 'Tempo de espera', sortable: true },
                { key: 'prestadorDescricao', name: 'prestadorDescricao', label: 'Prestador', sortable: true },
                { key: 'actions', label: 'Ações', class: 'text-center text-nowrap', fixed: true },
            ]
        },
        pacienteSearchFields() {

            return [
                { key: 'cidadao.nome', searchable: true },
                { key: 'cidadao.nomeSocial', searchable: true },
                { key: 'cidadao.cns', searchable: true },
                { key: 'cidadao.cpf', searchable: true },
                { key: 'cidadao.data_nascimento', searchable: true },
                { key: 'paciente.prontuario', searchable: true },
            ]
        },
        cidSearchFields() {

            return [
                { key: 'cid.codigo', searchable: true },
                { key: 'cid.nome', searchable: true },
            ]
        },
        ciapSearchFields() {

            return [
                { key: 'ciap.codigo', searchable: true },
                { key: 'ciap.descricao', searchable: true },
            ]
        },
    },
    created() {

        this.repositories = {
            fila: this.getConectaSusRepository('regulacao.fila')
        }

        this.load()
    },
    data: () => ({
        selectedAll: false,
        indeterminate: true,
        selectedCols: [
            'data',
            'prioridadeNome',
            'paciente',
            'cidDescricao',
            'statusNome',
            'tempoEspera',
            'prestadorDescricao',
            'pacienteIdade',
        ],
        loaded: false,
        exibirTodosFiltros: true,
        additionals: null,
        form: null,
        model: null,
        enums: { statusTipo },
        unwatchers: {
            unwatchPeriodo: null,
            unwatchPeriodoMovimentacao: null,
            unwatchPaciente: null,
            unwatchCid: null,
            unwatchCiap: null,
            unwatchIdadeDe: null,
            unwatchIdadeAte: null,
        },
        others: { moment },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.fila.list()
                .then(({ data }) => {

                    this.additionals = data.additionals
                    this.form = data.form
                    this.model = data.model

                    this.addWatchers()

                    this.loaded = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        addWatchers() {

            this.unwatchers.unwatchPeriodo = this.$watch('model.periodo', {
                deep: true,
                handler() {

                    this.loadFrom('periodo')
                }
            })

            this.unwatchers.unwatchPeriodoMovimentacao = this.$watch('model.periodoMovimentacao', {
                deep: true,
                handler() {

                    this.loadFrom('periodo_movimentacao')
                }
            })

            this.unwatchers.unwatchPaciente = this.$watch('model.paciente', {
                deep: true,
                handler() {

                    this.loadFrom('paciente')
                }
            })
            this.unwatchers.unwatchIdadeDe = this.$watch('model.idadeDe', {
                deep: true,
                handler() {

                    this.loadFrom('idade_de')
                }
            })

            this.unwatchers.unwatchIdadeAte = this.$watch('model.idadeAte', {
                deep: true,
                handler() {

                    this.loadFrom('idade_ate')
                }
            })
            this.unwatchers.unwatchCid = this.$watch('model.cid', {
                deep: true,
                handler() {

                    this.loadFrom('cid')
                }
            })

            this.unwatchers.unwatchCiap = this.$watch('model.ciap', {
                deep: true,
                handler() {

                    this.loadFrom('ciap')
                }
            })
        },
        async loadFromUnidadeReferencia() {

            this.setLoading()

            try {

                const oldForm = this.clone(this.form)
                const oldModel = this.clone(this.model)

                const wasUsuarioSolicitanteTodos = oldModel.usuarioSolicitanteId === null
                const wasPrestadorTodos = oldModel.prestador === null
                const wasStatusTodos = oldModel.status.length === oldForm.status.length
                const wasOpcaoRetiradaProtocoloAgendamentoTodos = oldModel.opcaoRetiradaProtocoloAgendamentoId === null
                const wasSexoTodos = oldModel.sexoId === null

                await this.listFrom('unidade_referencia')

                if (!wasUsuarioSolicitanteTodos && this.form.usuariosSolicitantes
                    .find(u => u.id === oldModel.usuarioSolicitanteId)
                ) {

                    this.model.usuarioSolicitanteId = oldModel.usuarioSolicitanteId

                    await this.listFrom('usuario_solicitante')
                }

                if (wasPrestadorTodos) {

                    this.model.prestador = oldModel.prestador

                    await this.listFrom('prestador')
                }
                else if (this.form.prestadores.find(p => p.value === oldModel.prestador)) {

                    this.model.prestador = oldModel.prestador

                    await this.listFrom('prestador')
                }

                if (!wasStatusTodos) {

                    this.model.status = oldModel.status.filter(id => this.form.status.find(s => s.id === id))

                    await this.listFrom('status')
                }

                if (!wasOpcaoRetiradaProtocoloAgendamentoTodos && this.form.opcoesRetiradaProtocoloAgendamento
                    .find(o => o.id === oldModel.opcaoRetiradaProtocoloAgendamentoId)
                ) {

                    this.model.opcaoRetiradaProtocoloAgendamentoId = oldModel.opcaoRetiradaProtocoloAgendamentoId

                    await this.listFrom('opcao_retirada_protocolo_agendamento')
                }

                this.model.grupos = oldModel.grupos.filter(id => this.form.grupos.find(g => g.id === id))

                await this.listFrom('grupo')

                this.model.exames = oldModel.exames.filter(id => this.form.exames.find(e => e.id === id))

                await this.listFrom('exame')

                this.model.procedimentosCirurgicos = oldModel.procedimentosCirurgicos
                    .filter(id => this.form.procedimentosCirurgicos.find(pc => pc.id === id))

                await this.listFrom('procedimento_cirurgico')

                this.model.especialidades = oldModel.especialidades
                    .filter(id => this.form.especialidades.find(e => e.id === id))

                await this.listFrom('especialidade')

                this.model.prioridades = oldModel.prioridades
                    .filter(id => this.form.prioridades.find(p => p.id === id))

                await this.listFrom('prioridade')

                this.model.cid = oldModel.cid
                this.model.ciap = oldModel.ciap

                await this.listFrom('ciap')

                if (!wasSexoTodos && this.form.sexos.find(s => s.id === oldModel.sexoId)) {

                    this.model.sexoId = oldModel.sexoId
                }

                this.$nextTick().then(() => this.$refs.DataTable.search())
            }
            catch (error) {

                this.handleError(error)
            }
            finally {

                this.unsetLoading()
            }
        },
        loadFrom(field) {

            this.setLoading()

            this.listFrom(field)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        async listFrom(field) {

            const { data } = await this.repositories.fila.list({ ...this.filters, load_from: this.camelToSnake(field) })

            if ('form' in data) {

                Object.keys(data.form).forEach(key => this.$set(this.form, key, data.form[key]))
            }

            Object.keys(data.model).forEach(key => this.$set(this.model, key, data.model[key]))
        },
        resetFilters() {

            this.unwatchers.unwatchPeriodo()
            this.unwatchers.unwatchPeriodoMovimentacao()
            this.unwatchers.unwatchPaciente()
            this.unwatchers.unwatchCid()
            this.unwatchers.unwatchCiap()
            this.unwatchers.unwatchIdadeDe()
            this.unwatchers.unwatchIdadeAte()
            this.$refs.Form.resetValidator()

            this.$nextTick().then(() => this.load())
        },
        selectAll(selected) {

            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
        rowClass(item, type) {

            if (type === 'row' && item) {

                if (item.pacienteEmObito) {

                    return 'table-purple'
                }
                else {

                    switch (item.statusTipoId) {

                        case this.enums.statusTipo.AGENDADO: {

                            return 'table-primary'
                        }
                        case this.enums.statusTipo.CANCELADO: {

                            return 'table-danger'
                        }
                        case this.enums.statusTipo.DEVOLVIDO: {

                            return 'table-warning'
                        }
                        case this.enums.statusTipo.REALIZADO: {

                            return 'table-success'
                        }
                        case this.enums.statusTipo.REAGENDADO: {

                            return 'table-orange'
                        }
                        default: {

                            return ''
                        }
                    }
                }
            }
        },
        handleImpressao(item) {

            this.setLoading()

            this.repositories.fila.getAtendimentos({id: item.id})
                .then(({ data }) => {

                    item['agendamentoData'] = data

                    if (data && data.sistema) {
                        item['sistema'] = data.sistema
                    }

                    if (data && data.examesIncluidos) {
                        item['examesIncluidos'] = data.examesIncluidos
                    }

                    if (data && data.infraestruturaSolicitante) {
                        item['infraestruturaSolicitante'] = data.infraestruturaSolicitante
                    }

                    if (data && data.prestadorExterno) {
                        item['prestadorExterno'] = data.prestadorExterno
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())

            this.$refs.ModalImpressao.open(item)
        }
    },
    mixins: [repository, error, stringCase, object],
    watch: {
        model: {
            deep: true,
            handler() {

                this.$nextTick().then(() => this.$refs.DataTable.clearTable())
            }
        },
        selectedCols(newValue) {

            this.selectedAll = newValue.length > 0 && newValue.length == this.optionalColumns.length
            this.indeterminate = newValue.length > 0 && newValue.length != this.optionalColumns.length
        },
    }
}
</script>

<style scoped>
.fila >>> .purple {
    color: #733380;
}

.fila >>> .table-purple {
    border-color: #a275a9;
    background-color: #e8dbe9;
}

.fila >>> .table-orange {
    border-color: #ffb067;
    background-color: #ffd7b2;
}
</style>